import { combineReducers } from "redux";
import { withReduxStateSync } from 'redux-state-sync';
import designerReducer from "./flowDesigner";
import portalReducer from "./portal";

const reducer = combineReducers({
  designer: designerReducer,
  portal: portalReducer,
});

export default withReduxStateSync(reducer);
